import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDown, LogOut } from "lucide-react";
import { useNavigate } from "react-router";
import { useAuthCtx } from "../../Auth/useAuthCtx.ts";
import { LogoutScreenPath } from "../../Auth/LogoutScreen.tsx";

function useGoToLogout() {
  const navigate = useNavigate();
  return () => navigate(LogoutScreenPath);
}

export function SignedInUserMenu() {
  const { user } = useAuthCtx();
  const goToLogout = useGoToLogout();

  return (
    <Menu>
      <MenuButton className="flex items-center gap-1 rounded-md px-2 py-1 text-sm text-slate-700 hover:bg-slate-100 focus:outline-none data-[open]:bg-slate-100">
        {user?.email}
        <ChevronDown className="w-4 h-4 text-slate-400" />
      </MenuButton>
      <MenuItems
        anchor="bottom end"
        transition
        className="z-50 rounded-md bg-white p-1 shadow-lg ring-1 ring-black/5 [--anchor-gap:6px] focus:outline-none transition duration-100 ease-out data-[closed]:opacity-0"
      >
        <MenuItem>
          <button
            type="button"
            onClick={goToLogout}
            className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-slate-700 data-[focus]:bg-slate-100"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}

export function SignedInUserSection() {
  const { user } = useAuthCtx();
  const goToLogout = useGoToLogout();

  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-sm text-slate-500 truncate">{user?.email}</span>
      <button
        type="button"
        onClick={goToLogout}
        className="shrink-0 flex items-center gap-1 rounded-lg px-3 py-2 text-sm hover:bg-slate-100"
      >
        <LogOut className="w-5 h-5" />
        Logout
      </button>
    </div>
  );
}
